import '../Styles/FormMember.css';
import { useState } from 'react';
import axios from 'axios';
import { HouseholdMember, MemberAddress } from './HouseholdMember';
import ChildrenArray from './ChildMember';
export default function MainFooter() {
    const [address, setAddress] = useState();
    const [householdMember, setHouseholdMember] = useState();
    const [numberOfFamilyMembersUnder18, setNumberOfFamilyMembersUnder18] = useState(0);
    const [childrenInfo, setChildrenInfo] = useState();
    const [error, setError] = useState('*Required field');
    const [marriedStatus, setMarriedStatus] = useState(false);
    const [spouse, setSpouse] = useState();
    const [childrenStatus, setChildrenStatus] = useState(false);
    const submitForm = async (e) => {
        e.preventDefault();
        console.log('House hold member', householdMember);
        console.log('address', address);
        console.log('spouse', spouse);
        console.log('childrenInfo', childrenInfo);        
        if (!householdMember) {
          setError('You need to fill out the household member form first');
          return;
        }
        if (!address) {
          setError('You need to fill out the address form first');
          return;
        }
        if (marriedStatus && !spouse) {
          setError('You need to fill out the spouse member form first');
          return;
        }
        if (!numberOfFamilyMembersUnder18) {          
            setError('You need to fill out the number of family members under 18 form first');
          return;
        }
        if (childrenStatus && !childrenInfo) {
            setError('You need to fill out the children form first');
          return;
        }
        const temp = {
            householdMember: householdMember,
            address: address,
            spouse: spouse,
            childrenInfo: childrenInfo
        }
        console.log('temp', temp);
        const response = await sendMemberToBackend(temp);
        console.log('response', response);
        setError(response.message);
    }
    const sendMemberToBackend = async (member) => {
        //http://localhost:3001/member
        //https://n2m4hmwxiw.us-east-1.awsapprunner.com/member
        console.log('member', member);
        const response = await axios.post('https://n2m4hmwxiw.us-east-1.awsapprunner.com/member', member)
            .then(repo => {
                return repo.data
            })
            .catch(error => { return error });
        return response;
    }
    const handleHouseholdMemberData = (data) => {
        console.log('data from household member', data);
        console.log('Object.keys(data).length', Object.keys(data).length);
        if (Object.keys(data).length > 0) setHouseholdMember(data);
        setNumberOfFamilyMembersUnder18(data.familyMembersUnder18);
    }
    const handleAddress = (data) => {
        setAddress(data);
        console.log('data from address', data);
    }
    const handleMarriedStatus = (e) => {
        const value = e.target.value;
        value === 'Yes' ? setMarriedStatus(true) : setMarriedStatus(false);
    };
    const handleSpouseMemberData = (data) => {
        setSpouse(data);
        setChildrenStatus(true);
        console.log('data from spouse member', data);
    }
    const handleNumberOfFamilyMembersUnder18Change = (e) => {
        const value = e.target.value;
        setNumberOfFamilyMembersUnder18(value);
        parseInt(value)>0?setChildrenStatus(true):setChildrenStatus(false);
    };
    const handelChildrenInfo = (info) => {
        console.log('childInfo', info);
        setChildrenInfo(info);
    numberOfFamilyMembersUnder18>0?setChildrenStatus(true):setChildrenStatus(false);
    }
    // useEffect(() => {
    //     console.log('useEffect called');'
    //     verifyData();
    // }, []);
    return (
        <div>
            <HouseholdMember onDataReceived={handleHouseholdMemberData} title='Household Member' />
            {householdMember && <MemberAddress onDataReceived={handleAddress} title='Physical Address' />}
            {address &&
                <div className='formMemberMainDiv'>
                    <div className='nameDiv'>
                        <label>Are you married?</label>
                        <select onChange={e => handleMarriedStatus(e)}>
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                        </select>
                    </div>
                </div>
            }
            {marriedStatus && <HouseholdMember onDataReceived={handleSpouseMemberData} />}
            {(spouse || !marriedStatus) && address &&
                <div className='formMemberMainDiv'>
                    <div className='nameDiv'>
                        <label>Number of Family Members Under 18*</label>
                        {/*  (() => assignedDataToMember())() */}
                        <input type='number' placeholder='Number of Family Members Under 18' min={0} max={10} onChange={(e) => handleNumberOfFamilyMembersUnder18Change(e)}
                            value={numberOfFamilyMembersUnder18} />
                    </div>
                </div>
            }
            {numberOfFamilyMembersUnder18 && parseInt(numberOfFamilyMembersUnder18) > 0 &&
                <ChildrenArray length={parseInt(numberOfFamilyMembersUnder18)} onChildrenDataReceived={handelChildrenInfo} />
            }
            <div className='formMemberMainDiv errorDiv'>
                <button type='submit' className="submitDiv" onClick={submitForm} >Submit form</button>
                {error && <p className='nameDiv'>{error}</p>}
            </div>
            <div className='formMemberMainDiv'>
                <script async src="https://js.stripe.com/v3/buy-button.js" />
                <stripe-buy-button
                    buy-button-id="buy_btn_1RnQgnH6GGGddHByInZmQm1d"
                    publishable-key="pk_test_51RnKnhH6GGGddHBy64q3MfByZ7Fo99cN4s3GzpHomlofcyC5EutPpDGG5xBmbYD8piKvgea4M6EnZTtQeI676NLz00y2JO7a1i"
                />
            </div>
        </div>
    )
}